import './_header.scss';
import React, { useContext, useState } from 'react';
import { Button, ControlLabel } from 'react-bootstrap';

import AlertComponent from '../../../../../../components/Alert';
import VirtualSelect from '../../../../../../components/Select/Virtual';
import Wall from '../../../components/Wall';

import { Context } from '../../index';
import { getErrorMessage } from '../../../../../../utils/helper';
import { servicesCategoriesHideHide } from '../../../../../../services/endpoints/services';
import { listUpdate } from '../../reducer';

const HideCategoriesHeader = () => {
  const [state, dispatch] = useContext(Context);
  const { categories } = state;

  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      await servicesCategoriesHideHide(selected);
      setError(null);
      dispatch(listUpdate());
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
    } finally {
      setLoading(false);
      setSelected([]);
    }
  };

  return (
    <Wall>
      <div>
        {isLoading ? <div className="modal-loader-small" /> : null}
        {error ? <AlertComponent text={error} /> : null}
        <ControlLabel>Hide for users</ControlLabel>
        <form onSubmit={onSubmit} className="services-hide__header-row">
          <VirtualSelect
            toggleBtnTitle="Choose category"
            optionsTitle="categories"
            onChange={(options) => setSelected(options)}
            options={categories?.visible}
            selectedOptions={selected}
            showLoader={false}
            toggleComponent={({ values }) => (
              <>
                {values?.length === 0 ? (
                  <span style={{ color: '#999' }}>Choose category</span>
                ) : (
                  <>
                    Categories
                    {' '}
                    <span className="options-count">{`(${values.length})`}</span>
                  </>
                )}
              </>
            )}
            needUpdateSelected
          />
          <Button type="submit" bsStyle="primary" disabled={isLoading}>
            Hide
          </Button>
        </form>
      </div>
    </Wall>
  );
};

export default HideCategoriesHeader;
